import { createFileRoute } from "@tanstack/react-router";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageTransition } from "@/components/PageTransition";
import { ArrowRight, Mail } from "lucide-react";

export const Route = createFileRoute("/get-found/thank-you")({
  head: () => ({
    meta: [
      { title: "You're in — The Outpost Creative" },
      {
        name: "description",
        content:
          "Your Get Found Playbook and personal access code are on their way to your inbox.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ThankYouRoute,
});

const BOOKING_URL =
  "https://api.leadconnectorhq.com/widget/booking/DYjiazsS0izL2JgzT2a8";

function ThankYouRoute() {
  return (
    <PageTransition>
      <div className="min-h-screen bg-[#eee9e3] text-[#151515]">
        <Navbar />
        <main className="pt-24 px-5 md:px-8 py-16 md:py-24">
          <div className="max-w-xl mx-auto text-center space-y-6">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#b85736]">
              <Mail className="h-8 w-8 text-[#151515]" />
            </div>
            <h1 className="font-heading text-4xl md:text-5xl font-extrabold uppercase tracking-tight leading-[0.95]">
              You're in. Check your email.
            </h1>
            <p className="text-lg text-[#3a3632]">
              Your playbook and personal access code are on their way to your
              inbox (usually within 2 minutes). Check spam or promotions if you
              don't see it.
            </p>
            <a
              href="https://theoutpost.agency/seo-audit"
              className="inline-flex items-center gap-2 bg-[#151515] text-[#eee9e3] font-bold uppercase tracking-wider px-8 py-4 hover:bg-[#b85736] hover:text-[#151515] transition-colors"
            >
              Start My Comprehensive Audit <ArrowRight className="h-5 w-5" />
            </a>
            <p className="font-mono text-sm text-[#6f675e]">
              Code didn't arrive in 10 minutes? Email adarian@theoutpost.agency.
            </p>
            <p className="font-mono text-sm text-[#6f675e]">
              Rather have us do it?{" "}
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#b85736] underline"
              >
                Book a free strategy call
              </a>
            </p>
          </div>
        </main>
        <Footer />
      </div>
    </PageTransition>
  );
}
